import React from 'react'
import { HelmetTags } from '../../components/HelmetTags'
import { Transaction as TransactionController } from '../../components/Transaction'

export const Transaction = (props) => {
  return (
    <>
      <HelmetTags page='transaction' />
      <TransactionController {...props} />
    </>
  )
}
